export const TRIM_TYPES = {
  LEADING: 1,
  TRAILING: 2,
  BOTH: 3,
}

export function trimTextValue(input, type) {
  try {
    type = _normalizeTrimType(type) // ensure type is valid

    // Handle an input onChange event-like object with a target.value
    if (
      input &&
      typeof input === "object" &&
      "target" in input &&
      input.target &&
      "value" in input.target
    ) {
      const originalValue = input.target.value
      const trimmed =
        originalValue == null ? originalValue : _trimTextValue(String(originalValue), type)

      // Update the event's target.value
      input.target.value = trimmed
      return input
    }

    // Handle a plain string
    if (typeof input === "string") {
      return _trimTextValue(input, type)
    }

    // Fallback: return input unchanged
    return input
  } catch (error) {
    console.error("Error trimming value:", error)
    return input
  }
}

function _normalizeTrimType(type) {
  if (type === TRIM_TYPES.LEADING || type === TRIM_TYPES.TRAILING || type === TRIM_TYPES.BOTH) {
    return type
  }
  return TRIM_TYPES.LEADING
}

function _trimTextValue(stringValue, type) {
  switch (type) {
    case TRIM_TYPES.LEADING:
      return stringValue.trimStart()
    case TRIM_TYPES.TRAILING:
      return stringValue.trimEnd()
    case TRIM_TYPES.BOTH:
      return stringValue.trim()
    default:
      return stringValue
  }
}